import { render, staticRenderFns } from "./EpcImgList.vue?vue&type=template&id=61208244"
import script from "./EpcImgList.vue?vue&type=script&lang=js"
export * from "./EpcImgList.vue?vue&type=script&lang=js"
import style0 from "./EpcImgList.vue?vue&type=style&index=0&id=61208244&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports